// extracted by mini-css-extract-plugin
export var active = "Accordion-module--active--928b7";
export var fadeInAnimation = "Accordion-module--fadeInAnimation--22b58";
export var panel = "Accordion-module--panel--5debf";
export var panelContentWrapper = "Accordion-module--panelContentWrapper--4691c";
export var title = "Accordion-module--title--63ebd";